var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#B2C8D8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7824 17.833L16.6666 14.7177C16.5259 14.5771 16.3353 14.499 16.1353 14.499H15.6259C16.4884 13.396 17.001 12.0086 17.001 10.4994C17.001 6.90909 14.0914 4 10.5005 4C6.90959 4 4 6.90909 4 10.4994C4 14.0896 6.90959 16.9987 10.5005 16.9987C12.01 16.9987 13.3976 16.4863 14.5008 15.6239V16.1332C14.5008 16.3332 14.5789 16.5238 14.7195 16.6644L17.8354 19.7797C18.1292 20.0734 18.6042 20.0734 18.8948 19.7797L19.7793 18.8954C20.0731 18.6017 20.0731 18.1267 19.7824 17.833ZM10.5005 14.499C8.29094 14.499 6.50018 12.7116 6.50018 10.4994C6.50018 8.29021 8.28781 6.49976 10.5005 6.49976C12.71 6.49976 14.5008 8.28708 14.5008 10.4994C14.5008 12.7085 12.7131 14.499 10.5005 14.499Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.b5dc1994.svg";
export { ForwardRef as ReactComponent };